import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies";
import App from "./App.vue";
import axios from "axios";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
// axios.defaults.baseURL = "http://localhost:8080";

import Intro from "./components/Intro.vue";

import InstaMarketing from "./components/event/InstaMarketing.vue";

import Login from "./components/user/Login.vue";
import Signup from "./components/user/Signup.vue";
import SignupEmail from "./components/user/SignupEmail.vue";
import SignupNaver from "./components/user/SignupNaver.vue";
import ResetPwViaEmail from "./components/user/ResetPwViaEmail.vue";
import ResetPwViaToken from "./components/user/ResetPwViaToken.vue";
import ResetPwViaLogin from "./components/user/ResetPwViaLogin.vue";
import MyInfo from "./components/user/MyInfo.vue";

import Msg from "./components/user/Msg.vue";
import MsgExistEmail from "./components/user/MsgExistEmail.vue";
import MsgExistNaver from "./components/user/MsgExistNaver.vue";
import MsgSignup from "./components/user/MsgSignup.vue";
import MsgSignupExist from "./components/user/MsgSignupExist.vue";
import MsgLogin from "./components/user/MsgLogin.vue";
import MsgLoginSuccess from "./components/user/MsgLoginSuccess.vue";

import Header from "./components/main/Header.vue";
import Footer from "./components/main/Footer.vue";

import Main from "./components/main/Main.vue";

import Pc4 from "./components/main/Pc4.vue";
import Insta from "./components/main/Insta.vue";
import Notice from "./components/main/Notice.vue";
import Rank from "./components/main/Rank.vue";
import Board from "./components/main/Board.vue";
import ShopData from "./components/main/ShopData.vue";
import NaverAd from "./components/main/NaverAd.vue";

import Membership from "./components/pay/Membership.vue";
import InstaSuccess from "./components/pay/InstaSuccess.vue";
import InstaFail from "./components/pay/InstaFail.vue";
import TossSuccess from "./components/pay/TossSuccess.vue";
import TossFail from "./components/pay/TossFail.vue";
import KakaoSuccess from "./components/pay/KakaoSuccess.vue";
import KakaoFail from "./components/pay/KakaoFail.vue";
import NaverSuccess from "./components/pay/NaverSuccess.vue";
import NaverFail from "./components/pay/NaverFail.vue";

Vue.config.devtools = true;
Vue.use(VueRouter);
Vue.use(VueCookies);

const router = new VueRouter({
	mode: "history",
	routes: [
		{ path: "/", component: Intro },
		{ path: "/instamaketing", component: InstaMarketing },
		{ path: "/signin", component: Login },
		{ path: "/signup", component: Signup },
		{ path: "/signup/email", component: SignupEmail },
		{ path: "/signup/naver", component: SignupNaver },
		{ path: "/resetpw/email", component: ResetPwViaEmail },
		{ path: "/resetpw/token", component: ResetPwViaToken },
		{ path: "/msg", component: Msg },
		{ path: "/msg/signup", component: MsgSignup },
		{ path: "/msg/signup/exist", component: MsgSignupExist },
		{ path: "/msg/signin", component: MsgLogin },
		{ path: "/msg/signin/success", component: MsgLoginSuccess },
		{ path: "/msg/exist/email", component: MsgExistEmail },
		{ path: "/msg/exist/naver", component: MsgExistNaver },
		{ path: "/main/pay/toss/success", component: TossSuccess },
		{ path: "/main/pay/toss/fail", component: TossFail },
		{ path: "/main/pay/insta/success", component: InstaSuccess },
		{ path: "/main/pay/insta/fail", component: InstaFail },
		{ path: "/main/pay/kakao/success", component: KakaoSuccess },
		{ path: "/main/pay/kakao/fail", component: KakaoFail },
		{ path: "/main/pay/naver/success", component: NaverSuccess },
		{ path: "/main/pay/naver/fail", component: NaverFail },
		// {
		// 	path: "/main",
		// 	components: {
		// 		default: Main,
		// 		header: Header,
		// 		footer: Footer
		// 	}
		// },
		{
			path: "/main/naverad",
			components: {
				default: NaverAd,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/main/pc4",
			components: {
				default: Pc4,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/main/insta",
			components: {
				default: Insta,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/notice/:id",
			components: {
				default: Notice,
				header: Header,
				footer: Footer
			}
		},
		// { path: '/main/pay',
		// components: {
		//   default: Membership,
		//   header: Header,
		//   footer: Footer
		//   }
		// },
		{
			path: "/main/rank",
			components: {
				default: Rank,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/main/board",
			components: {
				default: Board,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/main/shopdata",
			components: {
				default: ShopData,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/user/myinfo",
			components: {
				default: MyInfo,
				header: Header,
				footer: Footer
			}
		},
		{
			path: "/user/resetpw",
			components: {
				default: ResetPwViaLogin,
				header: Header,
				footer: Footer
			}
		},
		{ path: "*", redirect: "/" }
	]
});

new Vue({
	axios,
	router: router,
	render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js